export default __webpack_public_path__ + "static/media/nel_cesto.917ea8c7.mp3";